import { render, staticRenderFns } from "./Breadcrumb.vue?vue&type=template&id=03216ba2"
import script from "./Breadcrumb.vue?vue&type=script&lang=js"
export * from "./Breadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03216ba2')) {
      api.createRecord('03216ba2', component.options)
    } else {
      api.reload('03216ba2', component.options)
    }
    module.hot.accept("./Breadcrumb.vue?vue&type=template&id=03216ba2", function () {
      api.rerender('03216ba2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Breadcrumb/Breadcrumb.vue"
export default component.exports